<script setup lang="ts"></script>

<template>
  <svg width="204" height="163" viewBox="0 0 204 163" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M70.5459 82.356V88.7364L59.0393 91.8049C56.1741 92.5698 54.1796 95.1647 54.1796 98.1317V106.196H97.8231V98.1317C97.8231 95.1658 95.8286 92.5698 92.9634 91.8059L81.4568 88.7364V82.356"
      stroke="#293D66"
      stroke-width="3.63696"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M76.0007 84.3728C69.9747 84.3728 65.0899 77.305 65.0899 71.2782V69.0958C65.0899 63.069 69.9747 58.1837 76.0007 58.1837C82.0268 58.1837 86.9116 63.069 86.9116 69.0958V71.2782C86.9116 77.305 82.0268 84.3728 76.0007 84.3728Z"
      stroke="#293D66"
      stroke-width="3.63696"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M65.0899 69.0958C65.0899 63.069 69.9747 58.1837 76.0007 58.1837C82.0268 58.1837 86.9116 63.069 86.9116 69.0958"
      stroke="#FF531A"
      stroke-width="3.63696"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M105.097 95.0837H146.922" stroke="#293D66" stroke-width="3.63696" stroke-linecap="round" />
    <path d="M105.097 82.6797H146.922" stroke="#293D66" stroke-width="3.63696" stroke-linecap="round" />
    <path
      d="M162.466 69.1769V47.7256C162.466 42.9875 158.626 39.1465 153.887 39.1465H48.7936C44.0555 39.1465 40.2145 42.9875 40.2145 47.7256V71.3219"
      stroke="#FF531A"
      stroke-width="3.21716"
    />
    <path
      d="M1.60858 33.784V10.1877C1.60858 5.44958 5.44957 1.60858 10.1877 1.60858H32.1716"
      stroke="#A9B1C2"
      stroke-width="3.21716"
      stroke-linecap="round"
    />
    <path
      d="M201.609 33.784V10.1877C201.609 5.44958 197.768 1.60858 193.029 1.60858H171.046"
      stroke="#A9B1C2"
      stroke-width="3.21716"
      stroke-linecap="round"
    />
    <path
      d="M168.097 160.609L191.689 160.609C196.427 160.609 200.268 156.768 200.268 152.03L200.268 130.042"
      stroke="#A9B1C2"
      stroke-width="3.21716"
      stroke-linecap="round"
    />
    <path
      d="M1.60858 128.165L1.60858 151.761C1.60858 156.499 5.44957 160.34 10.1877 160.34H32.1716"
      stroke="#A9B1C2"
      stroke-width="3.21716"
      stroke-linecap="round"
    />
    <path
      d="M162.466 75.612V116.368C162.466 121.107 158.626 124.948 153.887 124.948H48.7936C44.0555 124.948 40.2145 121.107 40.2145 116.368V75.612"
      stroke="#293D66"
      stroke-width="3.21716"
      stroke-linecap="round"
      stroke-dasharray="6.43 6.43"
    />
    <path d="M23.5925 70.2494H180.161" stroke="#FF531A" stroke-width="3.21716" stroke-linecap="round" />
  </svg>
</template>
